export const ArrangementFilter = ({ options, value, onChange, counts, total }) => {
  const tabs = [{ key: "", label: "All arrangements", n: total }, ...options.map((o) => ({ key: o, label: o, n: counts[o] || 0 }))];
  return (
    <div className="mb-12" data-testid="careers-arrangement-filter">
      <p className="text-xs font-mono uppercase tracking-wider text-slate-400 mb-3">Filter by work arrangement</p>
      <div className="flex flex-wrap gap-2" role="tablist">
        {tabs.map((t) => (
          <button key={t.key || "all"} type="button" role="tab" aria-selected={value === t.key} onClick={() => onChange(t.key)}
            className={`px-4 py-2 text-xs font-mono uppercase tracking-wider border transition-colors duration-200 ${value === t.key ? "border-[var(--gold)] bg-[var(--gold)] text-[#0a0d14]" : "border-white/15 text-slate-300 hover:border-[var(--gold)] hover:text-gold"}`}
            data-testid={`careers-filter-${(t.key || "all").toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            {t.label} <span className="opacity-70 ml-1">{t.n}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
